import CrashLastRoundChip from '@/components/Crash/LastRoundChip';
import ForturnDoubleLastRoundsChip from '@/components/FortuneDouble/LastRoundsChip';
import DoubleLastRoundsChip from '@/components/Roulette/LastRoundsChip';
import LastRoundsChip from '@/components/core/Games/LastRounds/Chips/Chip';
import { GameID } from '@/enums/gameId';
import { LastRoundCardProps } from './props';

export default function LastRoundCard({
  gameId,
  isLoading,
  round,
  modal,
  link,
}: LastRoundCardProps) {
  switch (gameId?.toString()) {
    case GameID.Frost?.toString():
      return (
        <ForturnDoubleLastRoundsChip
          isLoading={isLoading}
          round={round}
          cover
          link={link}
          modal={modal}
        />
      );

    case GameID.Double?.toString():
      return (
        <DoubleLastRoundsChip
          isLoading={isLoading}
          round={round}
          cover
          link={link}
          modal={modal}
        />
      );
    case GameID.Crash?.toString():
    case GameID.CrashTrenball?.toString():
      return (
        <CrashLastRoundChip
          isLoading={isLoading}
          round={round}
          cover
          link={link}
          modal={modal}
        />
      );

    default:
      return (
        <LastRoundsChip
          isLoading={isLoading}
          round={round}
          gameId={gameId}
          cover
          modal={modal}
        />
      );
  }
}
